<template>
  <ListPageDesigner />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
